define('bizzabo/models/RelationsCollection',[
    'underscore',
    'bizzabo/models/SyncedCollection'
], function(
    _,
    SyncedCollection
    ) {

    var RelationsCollection = SyncedCollection.extend({

        coll1 : undefined,
        coll2 : undefined,
        coll1Name : undefined,
        coll2Name : undefined,
        id1 : undefined,
        cid1 : undefined,
        id2 : undefined,
        cid2 : undefined,

        initRelation : function(coll1, coll1Name, coll2, coll2Name) {
            this.coll1 = coll1;
            this.coll2 = coll2;
            this.coll1Name = coll1Name;
            this.coll2Name = coll2Name;
            this.id1 = this.coll1Name + "-id";
            this.cid1 = this.coll1Name + "-cid";
            this.id2 = this.coll2Name + "-id";
            this.cid2 = this.coll2Name + "-cid";
        },

        relationAdded : function(relation, model1, model2) {
            this.triggerOnModels(relation, "add", model1, model2);
        },

        relationRemoved : function(relation, model1, model2) {
            this.triggerOnModels(relation, "remove", model1, model2);
        },

        triggerOnModels : function(relation, msg, model1, model2) {
            if (_.isUndefined(model1)) {
                model1 = this.coll1.get(relation.get(this.id1) || this.coll1.get(this.cid1));
            }
            if (_.isUndefined(model2)) {
                model2 = this.coll2.get(relation.get(this.id2) || this.coll2.get(this.cid2));
            }
            model1 && model1.trigger(this.coll2Name + "Relation:" + msg, model2);
            model2 && model2.trigger(this.coll1Name + "Relation:" + msg, model1);
            this.trigger("relation:" + msg, model1, model2);
        },

        createRelation : function(model1, model2) {
            var map = {};
            model1.get("id") && (map[this.id1] = model1.get("id"));
            model2.get("id") && (map[this.id2] = model2.get("id"));
            model1.cid && (map[this.cid1] = model1.cid);
            model2.cid && (map[this.cid2] = model2.cid);
            return new this.model(map);
        },

        addRelation : function(model1, model2) {
            if (!this.haveRelation(model1, model2)) {
                var relation = this.createRelation(model1, model2);
                this.add(relation);
                this.relationAdded(relation, model1, model2);
                return relation;
            }
        },

        removeRelation : function(model1, model2) {
            var relation = this.findRelation(model1, model2);
            if (relation) {
                this.remove(relation);
                this.relationRemoved(relation, model1, model2);
                return relation;
            }
        },

        removeAllRelations : function(model) {
            var isModelType1 = (model.relationType == this.coll1Name);
            var modelsInRelations = this.joinByIdOrCid(model);
            for (var i = 0; i < modelsInRelations.length; i++) {
                var model2 = modelsInRelations[i];
                this.removeRelation(isModelType1 ? model : model2, isModelType1 ? model2 : model);
            }
        },

        haveRelation : function(model1, model2) {
            return this.findRelation(model1, model2) !== undefined;
        },

        findRelation : function(model1, model2) {
            for (var i = 0; i < this.length; i++) {
                var relation = this.at(i);
                if (this.isInRelation(model1, relation, false) && this.isInRelation(model2, relation, true)) {
                    return relation;
                }
            }
        },

        isInRelation : function(model, relation, isModel2) {
            var idCond = model.get("id") && (relation.get(isModel2 ? this.id2 : this.id1) === model.get("id"));
            return idCond || (model.cid && (relation.get(isModel2 ? this.cid2 : this.cid1) === model.cid));
        },

        joinByIdOrCid : function(model, collection) {
            var isModelType1 = (model.relationType == this.coll1Name);
            if (_.isUndefined(collection)) {
                collection = isModelType1 ? this.coll2 : this.coll1;
            }

            // get relations for model
            var idQuery = {}, cidQuery = {};
            cidQuery[isModelType1 ? this.cid1 : this.cid2] = model.cid;
            var resRelationsArray = this.where(cidQuery);

            var id = model.get("id");
            if (id) {
                idQuery[isModelType1 ? this.id1 : this.id2] = id;
                var idResRelationsArray = this.where(idQuery);
                resRelationsArray = _.union(idResRelationsArray, resRelationsArray);
            }

            // get models for those relations
            var models = [];
            for (var i = 0; i < resRelationsArray.length; i++) {
                var idModel = resRelationsArray[i];
                var idOrCid = idModel.get(isModelType1 ? this.id2 : this.id1) || idModel.get(isModelType1 ? this.cid2 : this.cid1);
                var resById = collection.get(idOrCid);
                var res = resById || collection.get(idOrCid);
                res && models.push(res);
            }
            return models;
        },

        hasOneToOnes : function(model) {
            // NOTICE: could be more efficient
            var models = this.joinByIdOrCid(model);
            for (var i = 0; i < models.length; i++) {
                var resModel = models[i];
                var resModels = this.joinByIdOrCid(resModel);
                if (resModels.length === 1) {
                    return true;
                }
            }
            return false;
        },

        getNonRelationModels : function(coll) {
            var isCollectionType1 = (coll.relationType == this.coll1Name);
            var idMap = {}, cidMap = {};
            for (var i = 0; i < coll.length; i++) {
                var model = coll.at(i);
                var id = model.get("id");
                var cid = model.cid;
                id && (idMap[id] = model);
                cid && (cidMap[cid] = model);
            }

            for (i = 0; i < this.length; i++) {
                var relation = this.at(i);
                id = relation.get(isCollectionType1 ? this.id1 : this.id2);
                cid = relation.get(isCollectionType1 ? this.cid1 : this.cid2);
                if (id && idMap[id]) {
                    var modelCid = idMap[id].cid;
                    modelCid && cidMap[modelCid] && delete cidMap[modelCid];
                    delete idMap[id];
                }
                if (cid && cidMap[cid]) {
                    var modelId = cidMap[cid].get("id");
                    modelId && idMap[modelId] && delete idMap[modelId];
                    delete cidMap[cid];
                }
            }

            return _.union(_.values(idMap), _.values(cidMap));
        },

        /**
         * When saving thisModel (which might contain only coll1.cid & coll2.cid),
         * the server might return a jsonModel of a relation (with no id or cids, just coll1.id & coll2.id).
         * In that case, this function compares using information from the models themselves.
         *
         * @param thisModel A relation
         * @param jsonModel A json containing relation's attributes
         * @return {boolean} true if the relation agrees with the json's attributes
         */
        //@Override
        nonObjectAttrsEquals : function(thisModel, jsonModel) {
            // check the normal equals (run the overridden function)
            if (!SyncedCollection.prototype.nonObjectAttrsEquals(thisModel, jsonModel)) {
                return false;
            }

            // check if model1 of both relations agrees based on information from the collections
            var thisModel1 = this.getModelFromRelation(thisModel.attributes, false);
            var jsonModel1 = this.getModelFromRelation(jsonModel, false);
            if (thisModel1 && jsonModel1 && (!thisModel1.equalsByIdOrCid(jsonModel1))) {
                return false;
            }

            // check if model2 of both relations agrees based on information from the collections
            var thisModel2 = this.getModelFromRelation(thisModel.attributes, true);
            var jsonModel2 = this.getModelFromRelation(jsonModel, true);
            return !(thisModel2 && jsonModel2 && (!thisModel2.equalsByIdOrCid(jsonModel2)));
        },

        getModelFromRelation : function(relationMap, isModel2) {
            var idKey = isModel2 ? this.id2 : this.id1;
            var cidKey = isModel2 ? this.cid2 : this.cid1;
            var coll = isModel2 ? this.coll2 : this.coll1;

            var id = relationMap[idKey];
            var cid = relationMap[cidKey];

            if (!_.isUndefined(id)) {
                return coll.get(id);
            }

            if (!_.isUndefined(cid)) {
                return coll.get(cid);
            }
        }
    });

    return RelationsCollection;

});
